import { synchronized } from '@ff-os/shared-utils/synchronized';
import { urls } from '@ff-os/shared-utils/urls';
import { AppThunkApi } from '../../store';
import { authorizeNew } from './authorizeNew';
import { authorizeWithSecret } from './authorizeWithSecret';

export const tryAuthorizeProject = synchronized(async (thunkApi: AppThunkApi) => {

    const state = thunkApi.getState().auth;

    if (!state.jwt) {
        if (state.secret) {
            try {
                await thunkApi.dispatch(authorizeWithSecret(state.secret)).unwrap();
            } catch (e) {
                throw new Error(`Auth error: ${urls.requestExistingGrant}.`);
            }
        } else {
            await thunkApi.dispatch(authorizeNew()).unwrap();
        }
    }
});